// extracted by mini-css-extract-plugin
export default {"separator":"Separator_separator__GTYmz","noBorder":"Separator_noBorder__XXKqL","noMargin":"Separator_noMargin__CHwwJ"};